import type { ButtonHTMLAttributes, ReactNode } from 'react'

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode
  label: string
}

export function IconButton({
  children,
  label,
  className = '',
  ...props
}: IconButtonProps) {
  return (
    <button
      type="button"
      aria-label={label}
      className={`w-8 h-8 flex items-center justify-center rounded-lg bg-surface-card dark:bg-dark-card text-ink dark:text-dark-ink border-2 border-ink dark:border-dark-border shadow-[2px_2px_0_#111111] dark:shadow-[2px_2px_0_#000000] hover:-translate-x-px hover:-translate-y-px hover:shadow-[3px_3px_0_#111111] dark:hover:shadow-[3px_3px_0_#000000] active:translate-x-px active:translate-y-px active:shadow-none transition-[transform,box-shadow] focus:outline-none focus:ring-2 ${className}`}
      {...props}
    >
      {children}
    </button>
  )
}
